import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_vm.isChangingUsedStock && _vm.item.status === _vm.wineStockStatus.DEFAULT ? _c(VBtn, {
    staticClass: "dfwa-btn --small highlight",
    attrs: {
      title: "Keep this stock",
      rounded: ""
    },
    on: {
      click: function click($event) {
        return _vm.$emit("cancel");
      }
    }
  }, [_c("i", {
    staticClass: "fas fa-check"
  })]) : _c(VBtn, {
    staticClass: "dfwa-btn --small",
    attrs: {
      title: _vm.isChangingUsedStock ? "Change used stock" : "Add product to " + (_vm.isBasket ? "cart" : "order"),
      rounded: "",
      disabled: _vm.isAddToCartDisabled,
      loading: _vm.isLoading
    },
    on: {
      click: function click($event) {
        return _vm.$emit("addProduct");
      }
    }
  }, [_c("i", {
    class: ["fas", _vm.isChangingUsedStock ? "fa-exchange-alt" : "fa-cart-plus"]
  })])], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };